// extracted by mini-css-extract-plugin
module.exports = {"itemsContainer":"index_itemsContainer__1Ngq9"};